import { api } from './client';

export type AIAction = 'reply' | 'summary' | 'classify';

export interface AIHelperResponse {
  action: AIAction;
  text: string;
  draft?: string;
  sources: Array<{ filename: string; source: string; score: number }>;
  classify: { priority?: string; support_line?: number; category?: string; reason?: string } | null;
}

export interface AIHelperOptions {
  message_id?: string;
  question?: string;
  refine?: boolean;
}

export interface ChatTurn { role: 'user' | 'assistant'; content: string }
export interface AskResponse {
  answer: string;
  sources: Array<{ filename: string; source: string; score: number }>;
}

export const aiHelperApi = {
  run: (ticket_id: string, action: AIAction, extra_query?: string, opts: AIHelperOptions = {}) =>
    api.post<AIHelperResponse>('/api/v1/ai', {
      ticket_id, action, extra_query,
      message_id: opts.message_id,
      question: opts.question,
      refine: opts.refine,
    }).then(r => r.data),

  ask: (question: string, history: ChatTurn[] = [], organization_id?: string) =>
    api.post<AskResponse>('/api/v1/ai/ask', {
      question, history, organization_id,
    }).then(r => r.data),
};
